import { render } from "./SupportDetailPopup.vue?vue&type=template&id=5c555858&scoped=true&ts=true"
import script from "./SupportDetailPopup.vue?vue&type=script&lang=ts"
export * from "./SupportDetailPopup.vue?vue&type=script&lang=ts"

import "./SupportDetailPopup.vue?vue&type=style&index=0&id=5c555858&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c555858"]])

export default __exports__